import { render, staticRenderFns } from "./c-header-image.vue?vue&type=template&id=40090bf9&scoped=true&"
import script from "./c-header-image.vue?vue&type=script&lang=js&"
export * from "./c-header-image.vue?vue&type=script&lang=js&"
import style0 from "./c-header-image.vue?vue&type=style&index=0&id=40090bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40090bf9",
  null
  
)

export default component.exports